import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-holder',
  templateUrl: './content-holder.component.html',
  styleUrls: ['./content-holder.component.css']
})
export class ContentHolderComponent {

  @Input() Title: string = "Content Title";
  @Input() Description: string = "Content Description";
  @Input() CssClass: string = "ColorFrontOffice";
  showDescription: boolean = true;

  constructor() {
    this.showDescription = (this.Description.length > 0);
  }
}
